module.exports = "# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n\n\n# Song Intro\n\n## Content\n\n###### Get ready to sing!\n\n## Notes\n\n&nbsp;\n\n\n# Song\nYouTube: a_hq2Bcb6Ug\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/03_song/song.md
// module id = 1521
// module chunks = 2